import React, { useRef } from "react";
import styles from "./FindInPageModal.module.scss";
import classNames from "classnames";
import { useFindInPage } from "../../hooks/FindInPageHooks/useFindInPage";
import useElementVisibility from "../../hooks/useElementVisibility";

function FindInPageModal({ value, onChange }) {
  const modalRef = useRef(null);
  const modalVisibility = useElementVisibility(modalRef);
  const findInPage = useFindInPage();

  const chevronButton = classNames(styles.button, styles.chevronButton);
  const closeButton = classNames(styles.button, styles.closeButton);

  return (
    <div
      className={`${styles.wrapper} ${modalVisibility.isOutsideViewport ? styles.top : ""}`}
      aria-label="Find In Page Modal"
    >
      <div className={`${styles.findInPageModal}`} ref={modalRef}>
        <button
          type="button"
          aria-label="Find previous"
          className={chevronButton}
          onClick={findInPage.previous}
        >
          <i className="tg-icons-ChevronUp"></i>
        </button>
        <button
          type="button"
          aria-label="Find next"
          className={chevronButton}
          onClick={findInPage.next}
        >
          <i className="tg-icons-ChevronDown"></i>
        </button>
        <div className={styles.inputWrapper}>
          <input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            type="text"
            placeholder="Search in page..."
            className={styles.input}
            autoFocus
          />
          <span className={styles.resultCount}>
            {findInPage.totalMatch > 0 ? findInPage.activeIndex + 1 : 0} /{" "}
            {findInPage.totalMatch}
          </span>
        </div>
        <button
          type="button"
          aria-label="Close"
          className={closeButton}
          onClick={findInPage.closeModal}
        >
          <i className="tg-icons-Cross"></i>
        </button>
      </div>
    </div>
  );
}

export default FindInPageModal;
